import React, { useState } from 'react';
import styles from './BrandGenAIMarketingDemo.module.css';

// Demo customer/product/activity data
const customers = [
  { id: 1, name: 'Alice', email: 'alice@email.com', phone: '+123456789', lastSearched: 'Hemp Hoodie', lastActive: '2025-06-10', conversion: 0.32 },
  { id: 2, name: 'Bob', email: 'bob@email.com', phone: '+987654321', lastSearched: 'Recycled Tote Bag', lastActive: '2025-06-09', conversion: 0.18 },
  { id: 3, name: 'Charlie', email: 'charlie@email.com', phone: '+192837465', lastSearched: 'Organic Cotton T-Shirt', lastActive: '2025-06-11', conversion: 0.44 },
];

const products = [
  { name: 'Hemp Hoodie', img: 'https://images.unsplash.com/photo-1519125323398-675f0ddb6308?auto=format&fit=crop&w=400&q=80' },
  { name: 'Recycled Tote Bag', img: 'https://images.unsplash.com/photo-1503342217505-b0a15ec3261c?auto=format&fit=crop&w=400&q=80' },
  { name: 'Organic Cotton T-Shirt', img: 'https://images.unsplash.com/photo-1512436991641-6745cdb1723f?auto=format&fit=crop&w=400&q=80' },
];

const demoMessages = {
  'Hemp Hoodie': 'Hi! Check out our new Hemp Hoodie – sustainable, stylish, and perfect for you. Get 10% off this week!',
  'Recycled Tote Bag': 'Eco-friendly and practical! Our Recycled Tote Bag is a must-have. Enjoy a special offer just for you.',
  'Organic Cotton T-Shirt': 'Experience comfort and sustainability with our Organic Cotton T-Shirt. Shop now and save!',
};

function BrandGenAIMarketingDemo() {
  const [selectedCustomer, setSelectedCustomer] = useState(customers[0]);
  const [messageType, setMessageType] = useState('email');
  const [sent, setSent] = useState(false);

  const handleSend = () => {
    setSent(true);
    setTimeout(() => setSent(false), 2000);
  };

  return (
    <div className={styles.page}>
      <h1 className={styles.title}>Marketing Automation Demo</h1>
      <p className={styles.desc}>
        This page shows how you can automatically target customers, track their activity, and send personalized messages based on their interests—all without using third-party marketing tools.
      </p>
      <div className={styles.flexRow}>
        {/* Customer Targeting */}
        <div className={styles.card}>
          <h2>Target Customers</h2>
          <ul className={styles.customerList}>
            {customers.map((c) => (
              <li key={c.id} className={selectedCustomer.id === c.id ? styles.selected : ''} onClick={() => setSelectedCustomer(c)}>
                <div className={styles.custName}>{c.name}</div>
                <div className={styles.custSearch}>Last searched: <b>{c.lastSearched}</b></div>
                <div className={styles.custActive}>Last active: {c.lastActive}</div>
                <div className={styles.custConv}>Conversion rate: <b>{Math.round(c.conversion*100)}%</b></div>
              </li>
            ))}
          </ul>
        </div>
        {/* Product Interest */}
        <div className={styles.card}>
          <h2>Product Interest</h2>
          <div className={styles.productGrid}>
            {products.map((p) => (
              <div key={p.name} className={styles.productCard}>
                <img src={p.img} alt={p.name} className={styles.productImg} />
                <div className={styles.productName}>{p.name}</div>
              </div>
            ))}
          </div>
        </div>
        {/* Messaging */}
        <div className={styles.card}>
          <h2>Send Custom Message</h2>
          <div className={styles.msgTypeBtns}>
            <button className={messageType==='email'?styles.activeBtn:''} onClick={()=>setMessageType('email')}>Email</button>
            <button className={messageType==='whatsapp'?styles.activeBtn:''} onClick={()=>setMessageType('whatsapp')}>WhatsApp</button>
          </div>
          <div className={styles.msgBox}>
            <div className={styles.msgTo}><b>To:</b> {messageType==='email'?selectedCustomer.email:selectedCustomer.phone}</div>
            <div className={styles.msgBody}>{demoMessages[selectedCustomer.lastSearched]}</div>
          </div>
          <button className={styles.sendBtn} onClick={handleSend} disabled={sent}>{sent ? 'Sent!' : 'Send Message'}</button>
        </div>
      </div>
      {/* Activity Tracking */}
      <div className={styles.activitySection}>
        <h2>Customer Activity & Conversion Tracking</h2>
        <table className={styles.activityTable}>
          <thead>
            <tr>
              <th>Name</th>
              <th>Last Searched</th>
              <th>Last Active</th>
              <th>Conversion Rate</th>
            </tr>
          </thead>
          <tbody>
            {customers.map((c) => (
              <tr key={c.id} className={selectedCustomer.id===c.id?styles.selectedRow:''}>
                <td>{c.name}</td>
                <td>{c.lastSearched}</td>
                <td>{c.lastActive}</td>
                <td>{Math.round(c.conversion*100)}%</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <div className={styles.footer}>
        <b>GenAI & RAG Automation:</b> Target, engage, and track customers using your own data—no third-party marketing tool required.
      </div>
    </div>
  );
}

export default BrandGenAIMarketingDemo;
